export const marqueeMessages = [
  "Welcome to CEG Tech Forum!",
  "Stay tuned for exciting updates and upcoming events!",
  "Empowering Innovation through Technology!",
];
